import { KNOWN_COLUMN_TYPES } from '@atlassian/jira-issue-table-common/src/constants.tsx';
import type { IssueRow_fieldSets$data } from '../__generated__/IssueRow_fieldSets.graphql';

export const getMergedFields = (fieldSetsData?: IssueRow_fieldSets$data | null) => {
	const nodes = fieldSetsData?.edges?.flatMap(
		(edgeData) => edgeData?.node?.fields?.edges?.map((edge) => edge?.node) ?? [],
	);

	let issueTypeField;
	let issueKeyField;
	let summaryField;
	let fieldId;

	nodes?.forEach((node) => {
		if (node?.__typename === 'JiraIssueTypeField') {
			issueTypeField = node;
		} else if (
			node?.__typename === 'JiraSingleLineTextField' &&
			node?.type === KNOWN_COLUMN_TYPES.ISSUE_KEY
		) {
			issueKeyField = node;
		} else if (
			node?.__typename === 'JiraSingleLineTextField' &&
			node?.type === KNOWN_COLUMN_TYPES.SUMMARY
		) {
			summaryField = node;
			fieldId = node?.id;
		}
	});

	return { issueTypeField, issueKeyField, summaryField, fieldId };
};
